import $ from 'jquery';
import  '../../../node_modules/slick-carousel/slick/slick.min.js';

$(document).ready(function(){
    const nextBtn = '<div class="next"><i class="icon-icon-arrowright"></i></div>';
    const prevBtn = '<div class="prev"><i class="icon-icon-arrowleft"></i></div>';

    $('[js-slider-solution]').slick({
        dots :false ,
        slidesToShow: 1,
        autoplay: false,
        mobileFirst: true,
        centerMode: true,
        nextArrow: nextBtn,
        prevArrow : prevBtn,
        appendArrows: $('[js-slider-solution-arrow]'),
        responsive: [{
            breakpoint: 480,
            settings: {
                slidesToShow: 2,
                infinite: true,
                centerMode: false
            }
        },
        {
            breakpoint: 960,
            settings: {
                slidesToShow: 3,
                infinite: true,
                centerMode: false
            }
        },
        {
            breakpoint: 1280,
            settings: {
                slidesToShow: 4,
                infinite: true,
                centerMode: false
            }
        }
        ]
    });
});


// WEBPACK FOOTER //
// ./resources/scripts/slider/_slider-solution.js